<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewDeviceUploadQR-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewDeviceUploadQR-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddNewDeviceUploadQR-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="AddNewDeviceUploadQR-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91c0-25.23,2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91c0,25.23-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <g transform="scale(0.12) translate(270, 270)">
              <path class="HubLogin-st2" d="M370.6 250.973a10 10 0 0 0-10 10v88.8c-.02 16.563-13.437 29.984-30 30H50c-16.562-.016-29.98-13.437-30-30v-260.6c.02-16.56 13.438-29.98 30-30h88.8a10 10 0 0 0 10-10c0-5.52-4.477-10-10-10H50c-27.602.03-49.97 22.398-50 50v260.594c.03 27.602 22.398 49.97 50 50h280.6c27.602-.03 49.97-22.398 50-50v-88.793a10 10 0 0 0-10-10zm6.03-237.533c-17.574-17.574-46.066-17.574-63.64 0L134.582 191.848c-1.223 1.223-2.105 2.738-2.566 4.402l-23.46 84.7c-.965 3.473.016 7.2 2.563 9.742a10.01 10.01 0 0 0 9.742 2.566l84.7-23.465a9.99 9.99 0 0 0 4.402-2.566l178.402-178.4c17.547-17.586 17.547-46.055 0-63.64zM156.37 198.348L302.383 52.332l47.1 47.1-146.016 146.016zm-9.406 18.875l37.62 37.625-52.04 14.418zm227.26-142.547L363.617 85.28l-47.094-47.094 10.6-10.605c9.762-9.762 25.6-9.762 35.352 0l11.738 11.734c9.746 9.773 9.746 25.6 0 35.36zm0 0"/>
            </g>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNewDeviceManual_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNewDeviceManual_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="HubLogin-wrapper-inputs lxn-margin-auto lxn-border-round">
      <div class="HubLogin-input-spacer">
      </div>
      <customInput v-model="uuid" @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" :placeHolder="$store.getters.language.texts.AddNewDeviceManualUUID_placeHolder" inputType="text">
      </customInput>
      <div class="HubLogin-input-spacer">
      </div>
      <DropDown v-model="type" :dropDownContex="dropDownType" />
      <div class="HubLogin-input-spacer">
      </div>
      <customInput v-model="firmwareYear" @focus="input2State='active'" @blur="input2State=''" :inputState="input2State" :placeHolder="$store.getters.language.texts.AddNewDeviceManualFirmwareYear_placeHolder" inputType="text">
      </customInput>
      <div class="HubLogin-input-spacer">
      </div>
      <customInput v-model="firmwareMonth" @focus="input3State='active'" @blur="input3State=''" :inputState="input3State" :placeHolder="$store.getters.language.texts.AddNewDeviceManualFirmwareMonth_placeHolder" inputType="text">
      </customInput>
      <div class="HubLogin-input-spacer">
      </div>
      <customText v-model="psk" @focus="input4State='active'" @blur="input4State=''" :inputState="input4State" :placeHolder="$store.getters.language.texts.AddNewDeviceManualPsk_placeHolder">
      </customText>
      <div class="HubLogin-input-spacer">
      </div>
    </div>
    <div class="HubLogin-button lxn-margin-auto lxn-w100 " style="margin-bottom: 20px">
      <CustomButton @click="addManual" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNewDeviceManual_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import CustomInput from '@/components/CustomInput.vue'
import CustomText from '@/components/CustomText.vue'
import DropDown from "@/components/DropDown";
import * as CONFIGS from "@/statics/configs";

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddNewDeviceManual',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton,
    CustomInput,
    CustomText,
    DropDown
  },
  data: function() {
    return {
      uuid: '',
      firmwareYear: '',
      firmwareMonth: '',
      psk: '',
      type: 0,
      input1State: '',
      input2State: '',
      input3State: '',
      input4State: '',
    }
  },
  computed: {
    dropDownType: function () {
      return {
        name: "AddManualType",
        title: this.$store.getters.language.texts.AddNewDeviceManual_type,
        selectedIndex: this.type,
        data: [
          {
            name: this.$store.getters.language.texts.AddNewDeviceManual_typeHub,
            icon: 'arrowLeft',
            value: 1
          },
          {
            name: this.$store.getters.language.texts.AddNewDeviceManual_typeHub2,
            icon: 'arrowLeft',
            value: 2
          },
          {
            name: this.$store.getters.language.texts.AddNode11_title,
            icon: 'arrowLeft',
            value: 11,
          },
          {
            name: this.$store.getters.language.texts.AddNode12_title,
            icon: 'arrowLeft',
            value: 12,
          },
          {
            name: this.$store.getters.language.texts.AddNode13_title,
            icon: 'arrowLeft',
            value: 13,
          },
          {
            name: this.$store.getters.language.texts.AddNode14_title,
            icon: 'arrowLeft',
            value: 14,
          },
          {
            name: this.$store.getters.language.texts.AddNode15_title,
            icon: 'arrowLeft',
            value: 15,
          },
          {
            name: this.$store.getters.language.texts.AddNode16_title,
            icon: 'arrowLeft',
            value: 16,
          },
          {
            name: this.$store.getters.language.texts.AddNode17_title,
            icon: 'arrowLeft',
            value: 17,
          },
        ]
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    addManual: function () {
      const type = this.dropDownType.data[this.type].value;
      this.input1State = '';
      const destinationUUID = parseInt(this.uuid, this.uuid.startsWith('0x') ? 16 : 10);
      if(this.uuid === ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert1);
        return;
      }
      if(this.$store.getters.getHubByUUID(destinationUUID) !== -1){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert2);
        return;
      }
      if(this.firmwareYear === ''){
        this.input2State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert3);
        return;
      }
      if(this.firmwareMonth === ''){
        this.input3State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert4);
        return;
      }
      if(this.psk === ''){
        this.input4State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert5);
        return;
      }
      try {
        this.psk = JSON.parse(this.psk);
        if (this.psk.length !== 32){
          this.input4State = 'error';
          alert(this.$store.getters.language.texts.AddNewDeviceManual_alert7);
          return
        }
      } catch{
        this.input4State = 'error';
        alert(this.$store.getters.language.texts.AddNewDeviceManual_alert6);
        return
      }
      const data = {
        deviceType: type,
        uuid: destinationUUID,
        fallback: this.psk,
        firmwareYear: this.firmwareYear,
        firmwareMonth: this.firmwareMonth
      };
      this.$store.commit('setScannedQR', data);
      if(data.deviceType === 1 || data.deviceType === 2){
        this.$router.push('/addHub');
      }else{
        if(this.$store.state.hubs.length === 0){
          this.$router.push('/AddNewDeviceNoHub');
        }else{
          this.$router.push('/addNode-' + data.deviceType);
        }
      }
    },
    next: function () {
      this.$router.push('/AddNewDeviceUploadQRScanQR');
    },
    next2: function () {
      this.$router.push('/AddNewDeviceUploadQRUploadQR');
    },
  }
}
</script>

<style>
  .AddNewDeviceUploadQR-topCurve-wrapper {
    height: 200px;
  }
  .AddNewDeviceUploadQR-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNewDeviceUploadQR-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNewDeviceUploadQR-st0 {
    fill: #ECECEC;
  }
	.AddNewDeviceUploadQR-st1 {
    fill: #54636C;
  }
	.AddNewDeviceUploadQR-st2 {
    fill: #21A4DE;
  }
</style>
